import { CloseOutlined } from '@ant-design/icons';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import { Button, Form, Input, message, Spin, Upload, UploadProps } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { UploadFile } from 'antd/lib/upload/interface';
import React, { useEffect, useState } from 'react';
import { IDocument, SComment } from '../../interfaces';

interface Props {
  productId: number;
  comment: SComment;
  onSubmitted: () => void;
}

const CommentEdit: React.FC<Props> = ({ comment, productId, onSubmitted }) => {
  /*----get img---*/

  useEffect(() => {
    if (comment) {
    }
  }, [comment]);
  const [selectedFile, setSelectedFile] = useState([] as any);
  const [fileList, setFileList] = useState<UploadFile[] | any>([]);

  const [mapSell, setMapSell] = useState(comment.documents);
  const [loading, setLoading] = useState(false);

  const handleUploadFiles = (files: any) => {
    const uploaded = [...selectedFile];

    files.some((file: any) => {
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
      setSelectedFile(uploaded);
    });
  };

  const handleFileEvent = (e: any) => {
    const chosenFiles = Array.prototype.slice.call(e);
    handleUploadFiles(chosenFiles);
  };

  const validateNumberOfFile = (fileList: number, mapSell: number) => {
    return fileList + mapSell;
  };

  const isMax = validateNumberOfFile(fileList.length, mapSell.length);

  /*--------------------handle get image and update-----------------------*/

  const handleGet = async (values: any) => {
    try {
      if (isMax > 4) {
        message.error('Not more than 4 files');
      } else {
        setLoading(true);
        const formData = new FormData();
        const fileIdArr = mapSell.map((item: IDocument) => item.id);
        for (let i = 0; i < fileList.length; i++) {
          formData.append('files', fileList[i].originFileObj);
        }
        const uploadData = await InquiryServices.upLoad(formData);

        for (let i = 0; i < uploadData.data.paths.length; i++) {
          fileIdArr.push(uploadData.data.paths[i].id);
        }

        const body = {
          content: values.comment,

          documentIds: fileIdArr
        };

        const putcmt = await InquiryServices.putEditComment(comment.id, body);
        if (putcmt.massage === 'success') {
          const commentres = await InquiryServices.getQuoteComment(productId);
          if (commentres) {
            comment = commentres.data;
          }
        }
        setLoading(false);
        message.success('Update success!');
        onSubmitted();
      }
    } catch (error) {
      message.error("Can't edit comment");
    }
  };

  /*--------------------dow imgae--------------------*/
  // const download = async () => {
  //   const originalImage =
  //     'https://cdn1.iconfinder.com/data/icons/ninja-things-1/1772/ninja-simple-512.png';
  //   const image = await fetch(originalImage);

  //   const nameSplit = originalImage.split('/');
  //   const duplicateName = nameSplit.pop();

  //   const imageBlog = await image.blob();
  //   const imageURL = URL.createObjectURL(imageBlog);
  //   const link = document.createElement('a');
  //   link.href = imageURL;
  //   link.download = '' + duplicateName + '';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  /*---------------delete image---------*/

  const removeItemIndex = (index: number) => {
    setFileList([
      ...fileList.filter(
        (selected: any) => fileList.indexOf(selected) !== index
      )
    ]);
  };
  const removeItem = (id: number) => {
    setMapSell([...mapSell.filter((element: IDocument) => element.id !== id)]);
  };

  const caculate = (arr1: number, arr2: number) => {
    return arr1 + arr2;
  };

  const validateFileType = (
    { type }: UploadFile,
    allowedTypes: string[] = ['image/jpeg', 'image/png']
  ) => {
    return allowedTypes.includes(type!);
  };

  const props: UploadProps = {
    onChange({ fileList: newFileList }) {
      // if (isMax > 4) {
      //   return;
      // }
      setFileList(newFileList);
    },
    beforeUpload: (file: any) => {
      const isAllowedType = validateFileType(file);
      if (!isAllowedType) {
        message.error(`${file.name} is not JPEG file`);
        return false;
      }
      // if (isMax > 4) {
      //   message.error(`Not more than 4 files`);
      //   return false;
      // }
      // setFileList((prev: any) => {
      //   if (prev.length < 4) {
      //     return [...prev, file];
      //   }
      //   return prev;
      // });
      // setFileList([...fileList, file]);
      // return false;
    }
  };
  return (
    <Spin spinning={loading}>
      <Form
        onFinish={handleGet}
        layout="vertical"
        style={{ width: '100%', display: 'flex', gap: '10px' }}
        initialValues={{
          ['comment']: comment.comment
        }}
      >
        <div className="attachUp" style={{ marginBottom: '10px' }}>
          <div style={{ marginBottom: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <p style={{ marginBottom: '0px', whiteSpace: 'nowrap' }}>
                Seller’s attachments
              </p>

              <Form.Item rules={[{ required: true }]}>
                <Upload
                  {...props}
                  multiple
                  fileList={fileList}
                  accept=".png, .jpg, .jpeg"
                  maxCount={4}
                  showUploadList={false}
                >
                  <Button> Upload</Button>
                </Upload>
              </Form.Item>
            </div>
          </div>
          <div
            className="scrollImg"
            style={{
              height: '90px',
              overflowY: 'scroll',
              overflowX: 'scroll',
              width: '320px'
            }}
          >
            <ul style={{ listStyleType: 'none', padding: '0' }}>
              {fileList.map((item: any, index: number) => (
                <li key={index}>
                  {item.name}
                  <span
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px'
                    }}
                    onClick={() => removeItemIndex(index)}
                  >
                    <CloseOutlined />
                  </span>
                </li>
              ))}
              <li>
                {mapSell.map((item: IDocument, index: number) => (
                  <p
                    key={index}
                    style={{
                      marginBottom: '0px',
                      color: '#A6A6A6',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <span
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px'
                      }}
                      onClick={() => removeItem(item.id)}
                    >
                      {item.fileName}
                      <CloseOutlined />
                    </span>
                  </p>
                ))}
              </li>
            </ul>
          </div>
        </div>
        {/* <div className="commentCard" style={{ marginBottom: '10px' }}>
          <div
            className="wrapTitle"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <p>{comment.owner}</p>
          </div> */}

        {/* <Form.Item
            name="comment"
            rules={[
              {
                required: true,
                message: 'Comment can not be empty'
              },
              {
                max: 150,
                message: 'Character must be less than 150!'
              }
            ]}
          > */}
        {/* <Input.TextArea defaultValue={comment.comment} maxLength={150} /> */}
        {/* <TextArea defaultValue={comment.comment} maxLength={150} />
          </Form.Item> */}

        <Form.Item
          name="comment"
          rules={[
            {
              required: true,
              message: 'Comment can not be empty'
            },
            {
              // max: 150,
              // message: 'Character must be less than 150!'
            }
          ]}
          style={{ width: '100%' }}
        >
          <div className="commentCard" style={{ marginBottom: '10px' }}>
            <div
              className="wrapTitle"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <p>{comment.owner}</p>
            </div>
            <p className="descript" style={{ marginBottom: '0px' }}>
              <TextArea defaultValue={comment.comment} maxLength={150} />
            </p>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                marginTop: '10px'
              }}
            >
              <Button
                htmlType="submit"
                type="primary"
                style={{
                  backgroundColor: '#2B2C51',
                  border: 'none',
                  borderRadius: '8px'
                }}
              >
                Send
              </Button>
            </div>
          </div>
        </Form.Item>

        {/* {'edit' ? (*/}
        {/* <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              marginTop: '20px'
            }}
          >
            <Button
              htmlType="submit"
              type="primary"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '20px',
                backgroundColor: ' #3c3d5f',
                border: 'none',
                borderRadius: '7px'
              }}
            >
              Send
            </Button>
          </div> */}
        {/* ) : null}  */}
        {/* </div> */}
      </Form>
    </Spin>
  );
};

export default CommentEdit;
